import { render, staticRenderFns } from "./OtpVerify.vue?vue&type=template&id=31243dd7&"
import script from "./OtpVerify.vue?vue&type=script&lang=js&"
export * from "./OtpVerify.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/authen.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/css/newLogin.css?vue&type=style&index=1&lang=css&"
import style2 from "./OtpVerify.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports